import { Inject, Injectable } from '@angular/core';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { animate, AnimationBuilder, AnimationPlayer, style } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';

import { debounceTime, filter, take } from 'rxjs/operators';
import { IsLoadingService } from '@service-work/is-loading';
import { MxLoggerService } from '@motivforce/mx-library-angular';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  splashScreenEl: any;
  player: AnimationPlayer;

  constructor(
    private animationBuilder: AnimationBuilder,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private isLoadingService: IsLoadingService,
    private mxLogger: MxLoggerService,
  ) {
    this.init();
  }

  /**
   * Initialize
   *
   * @private
   */
  private init(): void {
    // Get the splash screen element
    this.splashScreenEl = this.document.body.querySelector('#splash-screen');

    // If the splash screen element exists...
    if (this.splashScreenEl) {
      // Hide it on the first NavigationEnd event
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          take(1),
        )
        .subscribe(() => {
          setTimeout(() => {
            this.hide();
          });
        });

      this.isLoadingService
        .isLoading$()
        .pipe(debounceTime(200))
        .subscribe((isLoading) => {
          this.mxLogger.debug(
            'SplashScreenService',
            'init()  isLoadingService.isLoading=',
            isLoading,
          );
          if (isLoading) {
            this.show();
          } else {
            this.hide();
          }
        });
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Show the splash screen
   */
  show(): void {
    this.player = this.animationBuilder
      .build([
        style({
          opacity: '0',
          zIndex: '99999',
          backgroundImage: 'none',
          backgroundColor: 'rgba(32, 43, 83,.6)',
        }),
        animate('400ms ease', style({ opacity: '1' })),
      ])
      .create(this.splashScreenEl);

    setTimeout(() => {
      this.player.play();
    }, 0);
  }

  /**
   * Hide the splash screen
   */
  hide(): void {
    this.player = this.animationBuilder
      .build([
        style({ opacity: '1', backgroundImage: 'none', backgroundColor: 'rgba(32, 43, 83,.6)' }),
        animate(
          '400ms ease',
          style({
            opacity: '0',
            zIndex: '-10',
          }),
        ),
      ])
      .create(this.splashScreenEl);

    setTimeout(() => {
      this.player.play();
    }, 0);
  }
}
